function renderRecaptcha(element, key) {
    try {
        grecaptcha.render(element, {
            'sitekey': key,
            'callback': function (response) {
                let hiddenInput = element.nextSibling.nextSibling;
                hiddenInput.value = response;
            }
        });
    } catch (error) {
        console.log(error);
    }
}

var onloadCallback = function () {
    let sitekey = window.sitedata.recaptchakey;
    let recaptcha_fields = document.getElementsByClassName('g-recaptcha');

    if (recaptcha_fields.length) {
        for (let i = 0; i <= recaptcha_fields.length; i++) {
            let item = recaptcha_fields[i];

            if (item) {
                renderRecaptcha(item, sitekey);
            }
        }
    }
};

export class recaptcha {
    constructor() {
        this.head = document.getElementsByTagName('head')[0];
        this.script = document.createElement('script');

        this.init();
    }

    init() {
        let _this = this;

        if (_this.script && _this.head) {
            setTimeout(function () {
                _this.script.type = 'text/javascript';
                _this.script.src = "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
                _this.head.appendChild(_this.script);
            }, 3000);

            window.onloadCallback = onloadCallback;
        }
    }
}
